import React from 'react'
import slugify from 'slugify'
import { useSelector } from '~/store/hooks'

import { Link } from 'gatsby'
import { LABO_ICONS } from '~/utils/laboIcon'

const LaboCard = ({ labo }) => {
  const lang = useSelector((state) => state.lang)
  const prefix = lang === 'fr' ? '/labo' : '/en/lab'
  labo = labo.fields ? labo.fields : labo
  const title = labo.title
  const url = `${prefix}/${slugify(title, { remove: /[*+~.()'"!?:@,]/g }).toLowerCase()}`
  let iconString

  if (labo.mainTagIcon) {
    iconString = labo.mainTagIcon
  } else {
    iconString = labo.mainTag.fields
      ? labo.mainTag.fields.icon
      : labo.mainTag.icon
  }

  const IconComponent = iconString ? LABO_ICONS[iconString] : null

  return (
    <Link to={url} className="labo-card">
      {IconComponent && (
        <div className="icon-white flex-shrink-0 mr-4">
          {React.createElement(IconComponent)}
        </div>
      )}
      <p className="title-3-bold text-white">{title}</p>
    </Link>
  )
}

export default LaboCard
